// ============================================================
// CONFIGURATION CENTRALE — JEEM Services
// Modifiez ce fichier pour mettre à jour les informations du
// site (coordonnées, forfaits, prix, FAQ, réseaux sociaux...).
// Les éléments marqués [À REMPLACER] sont des placeholders.
// ============================================================

export const SITE = {
  companyName: "JeemServices",
  slogan: "Des services mobiles simples, avantageux et adaptés à vos besoins",

  // ---- WhatsApp (numéro au format international, sans + ni espaces) ----
  whatsappNumber: "15147783515",
  whatsappDisplay: "+1 514 778 3515",

  // ---- Coordonnées ----
  phone: "(514) 971-0820",
  email: "Jeemservices@gmail.com",
  address: "433 Rue Chabanel O, Montréal, QC H2N 2J9",

  // ---- Réseaux sociaux ----
  facebookUrl: "https://www.facebook.com/profile.php?id=61592511380511",
  instagramUrl: "https://www.instagram.com/jeemcareers/",

  // ---- Affichage des prix ----
  // Les prix sont volontairement masqués sur le site : ce message
  // s'affiche à la place sur chaque carte de forfait.
  priceNote: "Informez-vous des meilleurs prix dans votre région",
  // ---- Mesure publicitaire : coller les identifiants ici ----
  // (les scripts correspondants vont dans public/index.html)
  gtmId: "", // ex: "GTM-XXXXXXX"
  gaId: "", // ex: "G-XXXXXXXXXX"
  metaPixelId: "", // ex: "0000000000000000"
};

// Message WhatsApp générique (boutons principaux)
export const WHATSAPP_DEFAULT_MESSAGE =
  "Bonjour, je viens de votre site web et j'aimerais parler à un conseiller au sujet de vos offres de télécommunications.";

// ============================================================
// FORFAITS — DONNÉES DE DÉMONSTRATION [À REMPLACER]
// ============================================================
export const OFFERS = [
  {
    id: "essentiel",
    name: "Forfait Essentiel",
    data: "20 Go",
    calls: "Appels illimités",
    texts: "Textos illimités",
    price: "",
    featured: false,
    perks: ["Sans contrat", "Partage de connexion inclus", "Activation rapide"],
    whatsappMessage:
      "Bonjour, je viens de votre site web et je suis intéressé(e) par le Forfait Essentiel 20 Go. J'aimerais obtenir plus d'informations.",
    priceMessage:
      "Bonjour, je viens de votre site web et j'aimerais connaître le prix du Forfait Essentiel 20 Go dans ma région.",
  },
  {
    id: "performance",
    name: "Forfait Performance",
    data: "50 Go",
    calls: "Appels illimités",
    texts: "Textos illimités",
    price: "",
    featured: true,
    perks: ["Sans contrat", "Données reportées", "Assistance prioritaire WhatsApp"],
    whatsappMessage:
      "Bonjour, je viens de votre site web et je suis intéressé(e) par le Forfait Performance 50 Go. J'aimerais obtenir plus d'informations.",
    priceMessage:
      "Bonjour, je viens de votre site web et j'aimerais connaître le prix du Forfait Performance 50 Go dans ma région.",
  },
  {
    id: "ultime",
    name: "Forfait Ultime",
    data: "100 Go",
    calls: "Appels illimités",
    texts: "Textos illimités",
    price: "",
    featured: false,
    perks: ["Sans contrat", "Appels internationaux avantageux", "Idéal grands utilisateurs"],
    whatsappMessage:
      "Bonjour, je viens de votre site web et je suis intéressé(e) par le Forfait Ultime 100 Go. J'aimerais obtenir plus d'informations.",
    priceMessage:
      "Bonjour, je viens de votre site web et j'aimerais connaître le prix du Forfait Ultime 100 Go dans ma région.",
  },
];

// ============================================================
// AUTRES SERVICES (Internet, Téléphonie, TV)
// ============================================================
export const SERVICES = [
  {
    id: "internet",
    title: "Internet très haut débit",
    description:
      "Jusqu'à 2,5 Gb/s, sans contrat. Installation simple et rabais à vie sur certains forfaits.",
    points: ["Jusqu'à 2,5 Gb/s", "Sans contrat", "Rabais à vie"],
    image:
      "https://images.pexels.com/photos/12932191/pexels-photo-12932191.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Fibres optiques illuminées — Internet très haut débit",
    whatsappMessage:
      "Bonjour, je viens de votre site web et je suis intéressé(e) par votre service Internet très haut débit (jusqu'à 2,5 Gb/s). J'aimerais obtenir plus d'informations.",
  },
  {
    id: "telephonie",
    title: "Téléphonie",
    description:
      "Plans nationaux et internationaux compétitifs, adaptés à votre façon de communiquer.",
    points: ["Plans nationaux", "Plans internationaux", "Tarifs compétitifs"],
    image: null,
    imageAlt: "",
    whatsappMessage:
      "Bonjour, je viens de votre site web et je suis intéressé(e) par vos plans de téléphonie (nationaux et internationaux). J'aimerais obtenir plus d'informations.",
  },
  {
    id: "tv",
    title: "Télévision",
    description:
      "Les chaînes que vous aimez, incluant le sport, le cinéma et les nouveautés du moment.",
    points: ["Chaînes de sports", "Cinéma et séries", "Forfaits flexibles"],
    image:
      "https://images.unsplash.com/photo-1758687125973-ec9932a4245b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxmYW1pbHklMjB3YXRjaGluZyUyMHRlbGV2aXNpb24lMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4NzI3NTc5MHww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Famille regardant la télévision dans un salon moderne",
    whatsappMessage:
      "Bonjour, je viens de votre site web et je suis intéressé(e) par votre service de télévision. J'aimerais obtenir plus d'informations.",
  },
];

// ============================================================
// POURQUOI NOUS CHOISIR
// ============================================================
export const WHY_US = [
  {
    title: "Service personnalisé",
    description:
      "Un conseiller prend le temps de comprendre vos besoins avant de vous recommander quoi que ce soit.",
  },
  {
    title: "Réponse rapide",
    description:
      "Écrivez-nous sur WhatsApp et obtenez une réponse rapidement, sans attente téléphonique interminable.",
  },
  {
    title: "Offres adaptées à vos besoins",
    description:
      "Mobile, Internet, téléphonie ou TV : on vous propose seulement ce qui a du sens pour vous.",
  },
  {
    title: "Accompagnement par un conseiller",
    description:
      "De la première question à l'activation, vous êtes guidé par une vraie personne, du début à la fin.",
  },
];

// ============================================================
// TÉMOIGNAGES — CONTENU FICTIF DE DÉMONSTRATION [À REMPLACER]
// ============================================================
export const TESTIMONIALS = [
  {
    name: "Marie L.",
    location: "Montréal",
    quote:
      "J'ai écrit sur WhatsApp et j'ai eu une réponse en quelques minutes. Le conseiller m'a aidée à choisir le bon forfait sans pression.",
    avatar:
      "https://images.unsplash.com/photo-1758600587815-b654d1405e83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBkaXZlcnNlJTIwcG9ydHJhaXQlMjBzbWlsaW5nfGVufDB8fHx8MTc4NzI3NTc5MHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Karim B.",
    location: "Laval",
    quote:
      "Processus simple et rapide. J'ai comparé les offres sur le site, posé mes questions sur WhatsApp, et tout était réglé la journée même.",
    avatar:
      "https://images.pexels.com/photos/9489396/pexels-photo-9489396.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Sophie T.",
    location: "Longueuil",
    quote:
      "Enfin un service où on parle à une vraie personne. Le conseiller a pris le temps de tout m'expliquer clairement.",
    avatar: null,
  },
  {
    name: "Patrick G.",
    location: "Sherbrooke",
    quote:
      "J'ai regroupé mon Internet et mon mobile avec eux. Un seul contact pour tout, c'est tellement plus simple.",
    avatar: null,
  },
];

// ============================================================
// FAQ — Réponses facilement modifiables
// ============================================================
export const FAQ_ITEMS = [
  {
    question: "Comment puis-je souscrire à une offre ?",
    answer:
      "Choisissez l'offre qui vous convient, puis cliquez sur « Je suis intéressé ». Vous serez redirigé vers WhatsApp avec un message déjà préparé. Un conseiller prendra le relais pour finaliser votre inscription avec vous.",
  },
  {
    question: "Est-ce que je peux parler directement à un conseiller ?",
    answer:
      "Oui, absolument. C'est d'ailleurs notre façon préférée de travailler. Cliquez sur n'importe quel bouton WhatsApp du site pour discuter directement avec un membre de notre équipe.",
  },
  {
    question: "Comment fonctionne la demande via WhatsApp ?",
    answer:
      "Le bouton ouvre WhatsApp avec un message prérempli correspondant à l'offre choisie. Vous n'avez qu'à appuyer sur « Envoyer ». Un conseiller vous répond, répond à vos questions et vous guide pour la suite.",
  },
  {
    question: "Quels documents sont nécessaires ?",
    answer:
      "[À CONFIRMER PAR L'ENTREPRISE] En général, une pièce d'identité valide et vos informations de contact suffisent. Votre conseiller vous confirmera la liste exacte selon le service choisi.",
  },
  {
    question: "Puis-je changer de forfait ?",
    answer:
      "Oui. Nos offres sont sans contrat, donc vous gardez votre liberté. Écrivez-nous sur WhatsApp et un conseiller vous aidera à ajuster votre forfait selon vos besoins.",
  },
  {
    question: "Quels sont les délais de traitement ?",
    answer:
      "[À CONFIRMER PAR L'ENTREPRISE] Les demandes WhatsApp sont traitées rapidement pendant les heures d'ouverture. Votre conseiller vous indiquera le délai exact selon le service demandé.",
  },
];

// ============================================================
// IMAGES
// ============================================================
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1694057336527-fbc3e7c84890?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjB1c2luZyUyMHNtYXJ0cGhvbmUlMjBzbWlsaW5nJTIwYnJpZ2h0fGVufDB8fHx8MTc4NzI3NTc5MHww&ixlib=rb-4.1.0&q=85",
  heroAlt: "Cliente souriante utilisant son téléphone intelligent",
  logo: "/assets/logo.jpeg",
};
